import { Pipe, PipeTransform, Injectable } from '@angular/core';
import  moment from 'moment';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'dateFormatter'
})
export class DateFormatterPipe implements PipeTransform {
  transform(date: any, type: string): string {
    if (date) {
      if (type === "date") {
        let finalFormat = moment(date).date().toString()+`${this.getDateFormatter(moment(date).date())}`;
        return  finalFormat; 
      } else {
        let finalFormat = moment(date).format("Do MMM");
        return  finalFormat; 
      }
    }
    return '';
  }

  getDateFormatter(date: number) {
    if (date > 3 && date < 21) return 'th';
    switch (date % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    
    }  
  }

}
